// src/components/LoadingScreen.js

import React, { useEffect, useState } from "react";
import "components/Gallery/Gallery.css";
import Polaroid from "components/Polaroid/Polaroid";

import config from "config.js";
import loadingSeal from "assets/background_images/Seal_watermark.svg";

const Gallery = ({ stickers }) => {
  const [lionImages, setLionImages] = useState([]);

  const fetchImages = async () => {
    try {
      const response = await fetch(
        config.BACKEND_URL + "/data/random_images?limit=6"
      );
      if (!response.ok) {
        throw new Error("Failed to fetch lion images");
      }
      const data = await response.json();
      setLionImages(data.images);
    } catch (error) {
      console.error("Error fetching questions:", error);
    }
  };

  useEffect(() => {
    fetchImages();
  }, []);


  // Function to get a random sticker from the stickers array
  const getRandomSticker = () => {
    if (stickers && stickers.length > 0) {
      const randomIndex = Math.floor(Math.random() * stickers.length);
      return stickers[randomIndex];
    }
    return null; // Return null or a default value if no stickers are available
  };

  return (
    <>
      <div className="results-header">
        <h1>See what other Gusties have created!</h1>
        <p>A group of lions is a pride and we're proud to be Gusties.</p>
      </div>
     
      <div className="gallery-container">
      <img
        className="gallery-background-seal"
        src={loadingSeal}
        alt="Gustavus Seal"
      ></img>
        <div className="polaroid-images">
          {lionImages.map((image, index) => (
            <Polaroid key={index} image={image} sticker={getRandomSticker()}></Polaroid>
          ))}
        </div>
        <a className="load-more button secondary" onClick={fetchImages}>
            Load more
          </a>
      </div>
    </>
  );
};

export default Gallery;
